import { render, staticRenderFns } from "./c_banner.vue?vue&type=template&id=532ea684&scoped=true"
import script from "./c_banner.vue?vue&type=script&lang=js"
export * from "./c_banner.vue?vue&type=script&lang=js"
import style0 from "./c_banner.vue?vue&type=style&index=0&id=532ea684&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ea684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532ea684')) {
      api.createRecord('532ea684', component.options)
    } else {
      api.reload('532ea684', component.options)
    }
    module.hot.accept("./c_banner.vue?vue&type=template&id=532ea684&scoped=true", function () {
      api.rerender('532ea684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_banner.vue"
export default component.exports